export default "__VITE_ASSET__Ddk8pzNN__"